var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampConnectLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 432 432",
    style: {
      enableBackground: "new 0 0 432 432"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "104.3,180.7 85.5,180.7 85.5,271.6 20.2,271.4 73.1,168 77.1,171.2 82,166.5 87.3,171.2 92.2,166.5  96.5,170.8 98.4,169.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "98.4,169.1 96.5,170.8 92.2,166.5 87.3,171.2 82,166.5 77.1,171.2 73.1,168 85.5,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.5,153.2 20.2,263.3 57,156.3 62.2,171.4 72.9,143.8  "
  }), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.5,216.1c-0.2-0.4-0.4-0.9-0.6-1.3c-0.2-0.5-0.4-1-0.7-1.4c-0.2-0.5-0.4-0.9-0.6-1.2h-16.7 c-0.1,0.3-0.3,0.7-0.5,1.2c-0.2,0.5-0.4,1-0.7,1.4c-0.2,0.5-0.5,0.9-0.6,1.3c-0.2,0.4-1.1,2.4-1.1,2.4l-8.4,0 c1.4-3.4,3.7-8.3,5.2-11.6c1.5-3.3,2.8-6.3,4-8.9c1.2-2.7,2.1-4.9,2.9-6.6c0.8-1.8,2.1-4.6,2.1-4.6h11.4c0,0,1.1,2.4,1.6,3.6 c0.5,1.1,1.2,2.5,2,4.2c0.8,1.7,1.7,3.6,2.7,5.7c1,2.1,2,4.1,3,6.2c1,2.1,1.9,4,2.8,5.9c0.9,1.8,1.6,3.4,2.1,4.6 c0.1,0.2,0.7,1.6,0.7,1.6h-9.5C164.4,218.5,163.6,216.5,163.5,216.1z M153.1,194.3l-5.9,12.6h12L153.1,194.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.6,216.3c0,0.5,0,2.2,0,2.2H183v-2.2V189c0-0.5,0-2.2,0-2.2h11.8c0,0,1,2.3,1.6,3.5 c0.6,1.2,1.2,2.5,1.9,4c0.7,1.4,1.4,2.8,2,4.1c0.6,1.3,1,2.1,1.2,2.5c0.6-1.2,1.2-2.4,2-3.8c0.7-1.4,1.4-2.7,2.1-3.9 s1.2-2.3,1.6-3.2c0.4-0.9,1.4-3.2,1.4-3.2h12.1c0,0,0,1.6,0,2.2v27.4c0,0.5,0,2.2,0,2.2H212c0,0,0-1.6,0-2.2v-20.4h-0.1 l-10.7,20.8l-10.4-20.8h-0.1V216.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.7,189c0-0.5,0-2.2,0-2.2h31.5v20.6l-21.8,0v8.9c0,0.5,0,2.2,0,2.2h-9.6c0,0,0-1.6,0-2.2V189z  M251.8,201.4v-8.5l-12.5,0v8.5L251.8,201.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.3,235.4V267h-35.9v-31.6H193.3z M166.8,242.6v17.3h17.2v-17.3H166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.3,267.1h-7.9c0,0-1.2-1.4-1.5-1.8c-0.5-0.5-15.2-17-17.2-19.4l0,21.1h-9.4v-31.6h12.3 c0,0,12.8,14.6,14.3,16.3v-16.3h9.4V267.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.8,259.9l0,7.2h-32.7v-31.7h32.7l0,7.2h-23.7v5h16.2l0,6h-16.2v6.2H325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365,242.6h-22.7v17.3H365l7.5,7.2h-39.2v-31.7h39.2L365,242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.8,235.4l0,7.2h-12.5v24.5h-9.6v-24.5h-12.5v-7.2H411.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.6,267.1h-7.9c0,0-1.2-1.4-1.5-1.8c-0.5-0.5-15.2-17-17.2-19.4l0,21.1h-9.4v-31.6h12.3 c0,0,12.8,14.6,14.3,16.3v-16.3h9.4V267.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.7,271.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.7,186.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.2,197.6l-15.3,0v16.7l23.7,0l5.5,11.1H90.6c0,0,0-17.9,0-19.3c0-1.5,0-19.4,0-19.4h19.1L115.2,197.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.4,245.5H100l-0.1,17h48.1l5.6,11l-63.1,0c0,0,0-17.9,0-19.3c0-1.5,0-19.4,0-19.4l43.3,0L139.4,245.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.3,278.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.8,139.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampConnectLogo);
export default __webpack_public_path__ + "static/media/CampConnectLogo.57e20659bf4d0e3ce0fe5945e7d389c5.svg";
export { ForwardRef as ReactComponent };